import React from "react"

// importing google icon
import { GoogleOutlined } from '@ant-design/icons'

// import firebase from node-modules
import "firebase/app"

// auth is the "auth" configuration object which we are exporting from firebase.js
import { auth } from "../firebase"
import firebase from "firebase/app"

export default function Login() {
  alert("Please enable cookies for successful login");
  return (
    <div id='login-page'>
      <div id='login-card'>
        
        <h2>Welcome to Cryptomania!</h2>

        <div
          className='login-button google'
          // sign in using the auth object returned from firebase.js and pass a new instance of GoogleAuthProvider
          onClick={() => auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider())}
        >
          <GoogleOutlined /> Sign In with Google
        </div>

        <br/><br/>
        
        <div>
            <p className="footer__copy">&#169; codeStud. All rights reserved</p>
        </div>
      </div>
    </div>
  )
}